"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getTimeSegmentByHour = getTimeSegmentByHour;
exports.initializeState = initializeState;
exports.initializeTimeSegments = initializeTimeSegments;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _find3 = _interopRequireDefault(require("lodash/find"));
var _filters = require("../../constants/filters.constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function initializeTimeSegments() {
  return (0, _map2.default)(_filters.TIME_FILTER_SEGMENTS, function (timeSegment) {
    return _objectSpread(_objectSpread({}, timeSegment), {}, {
      selected: false
    });
  });
}
function initializeState(_temp) {
  var _ref = _temp === void 0 ? {
      legCount: 1
    } : _temp,
    legCount = _ref.legCount;
  return (0, _map2.default)(Array(legCount), function () {
    return {
      origin: initializeTimeSegments(),
      destination: initializeTimeSegments()
    };
  });
}
function getTimeSegmentByHour(hour) {
  var _find2;
  return (_find2 = (0, _find3.default)(_filters.TIME_FILTER_SEGMENTS, function (_ref2) {
    var from = _ref2.from,
      to = _ref2.to;
    return hour >= from && hour <= to;
  })) === null || _find2 === void 0 ? void 0 : _find2.code;
}